import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import SalesQuoteDetailsComponent from './sales-quote-details.component';
import SalesQuoteItemPropertiesComponent from './sales-quote-item-properties.component';
import { currency } from '../../../../../../common/services/common.service';

export const SalesQuoteComponent = ({
  handleInnerFormChange, selectedSalesQuote, selectedSalesQuoteNumber, back, handleFormSubmit, sQCreateSelectOption, selectedSalesQuoteItems,
  opportunities, contacts, customers, generateSalesQuoteNumber, getProductImage, handleFormItemChange,
  employee, organizationUnits, priceBooks, termslibraries, salesQuoteFrequency, salesQuotePriority, tagNames,
  calculatedValues, itemIndex
}: any) => {

  const title = `Sales Quote ${selectedSalesQuoteNumber?.SalesQuoteNumber || ''} - Details`;
  const tabItems = [
    {
      id: 1,
      title: (title),
      component: <SalesQuoteDetailsComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedSalesQuote={selectedSalesQuote}
        generateSalesQuoteNumber={generateSalesQuoteNumber}
        selectedSalesQuoteNumber={selectedSalesQuoteNumber}
        sQCreateSelectOption={sQCreateSelectOption}
        customers={customers}
        contacts={contacts}
        opportunities={opportunities}
        employee={employee}
        organizationUnits={organizationUnits}
        priceBooks={priceBooks}
        termslibraries={termslibraries}
        salesQuoteFrequency={salesQuoteFrequency}
        salesQuotePriority={salesQuotePriority}
        tagNames={tagNames}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Item Properties',
      component: <SalesQuoteItemPropertiesComponent
        handleFormItemChange={handleFormItemChange}
        selectedSalesQuoteItems={selectedSalesQuoteItems}
        getProductImage={getProductImage}
        itemIndex={itemIndex}
      />,
      isVisible: true,
    },

  ]

  return (
    <>
      <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

        <TabContainer tabItems={tabItems} />
      </div>

      <div className="sticky bottom-0 w-full h-20 p-5 flex items-center justify-between bg-slate-300">
        <div className=' grid grid-cols-2 gap-2'>
          <div className='flex w-full justify-start items-start'>

            <div className='p-2 grid grid-cols-4 gap-4 font-semibold'>
              <div>
                <span> Item Count = {calculatedValues?.ItemCount || 0}</span>
              </div>
              <div>
                <span> Total Amount = {currency(calculatedValues?.TotalAmount || 0)}</span>
              </div>
              <div>
                <span> Tax Amount = {currency(calculatedValues?.TaxAmount || 0)}</span>
              </div>
              <div>
                <span> Grand Total = {currency(calculatedValues?.GrandTotalAmount || 0)}</span>
              </div>
            </div>
          </div>
          <div className='flex w-auto justify-end items-end'>
            <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
              Back
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}

              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}
export default SalesQuoteComponent;
